var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.996C16 12.1331 15.9738 12.2596 15.9214 12.3755C15.869 12.4914 15.7904 12.6021 15.6857 12.7075L9.56385 18.7312C9.39096 18.9104 9.17616 19 8.91945 19C8.7518 19 8.59725 18.9578 8.4558 18.8735C8.31434 18.7945 8.2017 18.6838 8.11788 18.5415C8.03929 18.4045 8 18.2516 8 18.083C8 17.83 8.0943 17.6061 8.28291 17.4111L13.7996 11.996L8.28291 6.58103C8.0943 6.38603 8 6.16469 8 5.917C8 5.74308 8.03929 5.58762 8.11788 5.45059C8.2017 5.31357 8.31434 5.20553 8.4558 5.12648C8.59725 5.04216 8.7518 5 8.91945 5C9.17616 5 9.39096 5.08696 9.56385 5.26087L15.6857 11.2846C15.7904 11.39 15.869 11.5007 15.9214 11.6166C15.9738 11.7325 16 11.859 16 11.996Z",
    fill: "#03122E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/ChevronRight.13660715033cfc7b87e43173b73a2708.svg";
export { ForwardRef as ReactComponent };